/* IPA helper utilities  ------------------------------------------ */
import {
    IPA_PRODUCT_TYPES,
    DISTRIBUTION_VARIANTS,
} from "@/IPA/IPAProducts";

export function deriveIpaSelections(offeredProducts = []) {
    /* ---------------- distribution ---------------- */
    const firstDist = offeredProducts.find(
        (p) => p.specifications?.type === IPA_PRODUCT_TYPES.DISTRIBUTION
    );
    let distributionType = null;
    if (firstDist) {
        const d = firstDist.specifications.distribution?.value;
        if (d === DISTRIBUTION_VARIANTS.METALLIC.value) distributionType = 1;
        if (d === DISTRIBUTION_VARIANTS.MODULAR_RR.value) distributionType = 2;
        if (d === DISTRIBUTION_VARIANTS.MODULAR_EC.value) distributionType = 3;
    }

    /* ---------------- box ---------------- */
    const firstBox = offeredProducts.find(
        (p) => p.specifications?.type === IPA_PRODUCT_TYPES.BOX
    );
    let boxType = 3;
    if (firstBox) {
        // The Sistema boxes have `.09` ending; SP have `.44`.
        boxType = /\.44$/.test(firstBox.product_code) ? 1 : 2;
    }

    /* ---------------- temp‑kit ---------------- */
    const hasKit = offeredProducts.some(
        (p) => p.specifications?.type === IPA_PRODUCT_TYPES.TEMPERATURE_CONTROL
    );
    const tempControlKit = hasKit ? 2 : 1;

    return { boxType, distributionType, tempControlKit };
}
